/* eslint 'jsx-a11y/anchor-is-valid': 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import '../../../../../Assets/EnsembleStyles/Administration/buildinginstallation.css';
import FailedBuildingInstallations from './BuildingsFailedInstallations';
import InstalledBuilding from './InstalledBuildings';




class BuildingInstallations extends Component {

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ 
                failed_installations: nextProps.buildings_discovering_list_response,
                sucess_installations: nextProps.Discovered_buildings_list_response 
             })
        }
    }

    constructor(props) {
        super(props)
          this.state = {
            loading: true,
            deletemodal: false,
            error_msg: false,
            failed_installations:null,
            sucess_installations:null,
            searchTermVal: '',
            redirect: false,
            back_redirect: false,
            addnewbuilding_redirect:false,
      }
      
    }

    redirect(link_name) {
        if (link_name === "back_to_administration") { this.setState({ redirect: true, back_redirect: true }); }
        if (link_name === "installations_redirect") { this.setState({ redirect: true, addnewbuilding_redirect: true }); }
    }



    render() {


        // Redireaction
        let {redirect,back_redirect,addnewbuilding_redirect} = this.state;
        if (redirect && back_redirect) { return <Redirect to={"/SystemAdmin/Administration"} /> }
        if (redirect && addnewbuilding_redirect) { return <Redirect to={"/SystemAdmin/AddNewBuilding"} /> }
        
       

        
        //Rendering
        return (
            <div className="admin_container"  >

            {/* Header */}
                <div  className="bldng_installation_titlebar">
                    <div className="dbd_subheader">
                    <h2 className="dbd_sub_heading">Building Installations</h2>
                    </div>
                </div>




                <div className="discovery_content1 sub_text">
                <p >View the status of buildings being installed. Click links under Name or Status for details or select a row and click an action button on the right.</p>
                <a className="bld_installations_nv_link link_cursor" onClick={() => { this.redirect("installations_redirect") }}>Add a New Building </a>
            
                <div className="tableandbtns">

                <FailedBuildingInstallations  />
          
                    </div>
             </div>

                {/* Content 1 */}


                {/* Content 2 */}
                
                <InstalledBuilding  />
          
                <div className="back_div">
                       <Button className="btn-gray btn-md"   onClick={() => { this.redirect("back_to_administration") }}  > {"< Back"}</Button>
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
     buildings_discovering_list_response: state.InstallationsRootReducer.Installations,
     Discovered_buildings_list_response: state.InstallationsRootReducer.BuildingsDiscovered,
    };
};

export default connect(mapStateToProps, null)(BuildingInstallations);
  